export const AP_FEATURE_FLAG = 'assortment-preview';

export const AP_OFF_TREATMENT = 'off';
export const AP_ON_TREATMENT = 'on';

export const AP_MODULES_TREATMENT = 'modules';
export const AP_MODULES_AND_PAGE_TREATMENT = 'modules-and-page';
export const AP_MODULES_PAGE_AND_VIDEO_TREATMENT = 'modules-page-and-video';

export const AP_PAGE_ORGANIC = 'modules-and-page-organic'; // only used for customers who land organically on the preview page first
export const AP_LOCALSTORAGE_KEY = 'assortmentPreviewExperiment';
